import React from "react";
import BasketItemRow from "../items/BasketItemRow";
import type { PackType } from "../../../../../../../../common-deprecated/types/CommonTypes";
import useFinancePackConfigurables from "../../../../../hooks/shared/financepacks/useFinancePackConfigurables";
import type { FinancePackConfigurablesType } from "../../../../../../../shared-logic/types/FinanceTypes";

type PropType = {
    pack: PackType;
    equipment: FinancePackConfigurablesType;
};
const BasketFinancePackEquipment = (props: PropType): JSX.Element => {
    const { pack, equipment } = props;
    const { isChecked, onChange } = useFinancePackConfigurables(equipment, pack);

    return (
        <BasketItemRow
            name={`+ ${equipment.name}`}
            price={equipment.price}
            removeItem={() => onChange(isChecked, true)}
        />
    );
};

export default BasketFinancePackEquipment;
